import { RegisteredAssetDetailModel } from '@casops/store/apis/registeredAssetsApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface GeofenceData {
  where: string;
  version: number;
  ts?: string;
  error: boolean;
}

interface UseAssetGeofenceTableDataProps {
  asset?: RegisteredAssetDetailModel;
}

export const useAssetGeofenceTableData = ({ asset }: UseAssetGeofenceTableDataProps) => {
  const { t } = useTranslation();

  return useMemo<GeofenceData[]>(() => {
    if (!asset) {
      return [];
    }

    return [
      {
        where: t('GeofenceAssetVersion'),
        version: asset.geoVer,
        ts: asset.geoTs,
        error: asset.geoVer !== asset.siteGeoVer,
      },
      {
        where: t('GeofenceSiteVersion'),
        version: asset.siteGeoVer,
        ts: asset.siteGeoTs,
        error: false,
      },
    ];
  }, [asset, t]);
};
